import { supabase, isAbortError } from '../../lib/supabase';

const checkIsAbortError = (err: unknown): boolean => {
  if (typeof isAbortError === 'function' && isAbortError(err)) return true;
  if (!err || typeof err !== 'object') return false;
  const e = err as { name?: string; message?: string; isAcquireTimeout?: boolean; code?: string | number };
  return (
    e.name === 'AbortError' ||
    (typeof e.message === 'string' && e.message.includes('signal is aborted')) ||
    e.isAcquireTimeout === true ||
    e.code === 20 ||
    e.code === 'ABORT_ERR'
  );
};

export const getSessionWithRetry = async (
  maxRetries = 3,
  delayMs = 500
): Promise<Awaited<ReturnType<typeof supabase.auth.getSession>> | null> => {
  let currentDelay = Math.min(delayMs, 50);
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const result = await supabase.auth.getSession();
      return result;
    } catch (err) {
      const isAbort = checkIsAbortError(err);

      if (isAbort && attempt < maxRetries) {
        console.warn(`🔄 Session fetch aborted (attempt ${attempt}/${maxRetries}), retrying in ${currentDelay}ms...`);
        await new Promise((resolve) => setTimeout(resolve, currentDelay));
        currentDelay = Math.min(currentDelay * 2, 5000);
      } else {
        throw err;
      }
    }
  }
  return null;
};
